import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LogoImg from "../../Components/Assests/Images/logo.png";
import ReceptionistLayout from '../../Layouts/Receptionist/ReceptionistLayout';
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import { saveConsultation } from "../../Services/doctorService";
import { useMasterData } from '../../Components/Common/commonEvents';
import { appointmentDetailsById } from "../../Services/appointmentService";
import { toInputDate } from "../../Utils/dateUtils";
import { BASE_DOCS_API_GET, BASE_IMAGE_API_GET } from "../../config";

export default function ReceptionConsultation() {

    const navigate = useNavigate();
    const { appointmentId } = useParams();
    const location = useLocation();

    const appointment = location.state;
    const [sessionUserData, setSessionUserData] = useState([]);
    const [previewLoadingId, setPreviewLoadingId] = useState(null);
    const [appointmentPreview, setAppointmentPreview] = useState(null);

    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem("userData"));

        if (userData) {
            setSessionUserData(userData);
        }
    }, []);

    const [medicalHistory, setMedicalHistory] = useState({
        allergy: "",
        bpHistory: "",
        diabetes: "",
        medications: "",
        epilepsy: false,
        asthma: false,
        others: false,
    });

    const [medicalDetails, setMedicalDetails] = useState({
        allergyDetails: "",
        bpDetails: "",
        diabetesDetails: "",
        medicationDetails: "",
        othersDetails: "",
    });

    const {
        appointmentsByPatientId,
        appointmentFiles,
        procedures,
        fetchAppointmentByPatientId,
        fecthAppointmentfiles,
        fetchProcedureMasters,
    } = useMasterData();

    useEffect(() => {
        if (!sessionUserData?.OrgId || !appointment?.PatientId) return;

        fetchAppointmentByPatientId(sessionUserData.OrgId, appointment.PatientId);
    }, [sessionUserData?.OrgId, appointment?.PatientId]);

    const patientAppointments = Array.isArray(appointmentsByPatientId)
        ? appointmentsByPatientId
        : appointmentsByPatientId
            ? [appointmentsByPatientId]
            : [];

    const formatDate = (value) =>
        value
            ? new Date(value).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            })
            : "-";

    const formatTime = (value) =>
        value
            ? new Date(value).toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })
            : "-";

    const [vitals, setVitals] = useState({
        bloodPressure: "120/80",
        heartRate: "72 bpm",
        temperature: "98.6°F",
        weight: "75 kg",
    });

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
    });

    const [activeClinicalTab, setActiveClinicalTab] = useState("diagnosis");
    const [activeScreenTab, setActiveScreenTab] = useState("history");

    const [consultation, setConsultation] = useState({
        diagnosis: "",
        treatmentPlan: "",
        followUpDate: "",
        prescription: [
            {
                medicine: "",
                dosage: "0-0-0",
                duration: "",
            },
            {
                medicine: "",
                dosage: "0-0-0",
                duration: "",
            },
            {
                medicine: "",
                dosage: "0-0-0",
                duration: "",
            },
        ],
        advice: "",
        procedures: [
            {
                procedureId: 1,
                procedureName: "",
                qty: 1,
                rate: "",
                discount: "",
                total: "",
                notes: "",
                isPaid: false,
                paidAmount: "",
            },
        ],
    });

    const handleMedicalHistoryChange = (e) => {
        const { name, value, type, checked } = e.target;

        setMedicalHistory((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleMedicalDetailsChange = (e) => {
        const { name, value } = e.target;

        setMedicalDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleVitalsChange = (e) => {
        const { name, value } = e.target;
        setVitals((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleConsultationChange = (e) => {
        const { name, value } = e.target;

        setConsultation((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handlePrescriptionChange = (index, field, value) => {
        setConsultation((prev) => {
            const updatedPrescription = [...prev.prescription];

            updatedPrescription[index] = {
                ...updatedPrescription[index],
                [field]: value,
            };

            return {
                ...prev,
                prescription: updatedPrescription,
            };
        });
    };

    const removePrescriptionRow = (index) => {
        setConsultation((prev) => ({
            ...prev,
            prescription: prev.prescription.filter((_, i) => i !== index),
        }));
    };

    const handleProcedureChange = (index, field, value) => {
        setConsultation((prev) => {
            const updatedProcedures = [...prev.procedures];

            const updatedItem = {
                ...updatedProcedures[index],
                [field]: value,
            };

            const qty = Number(field === "qty" ? value : updatedItem.qty) || 0;
            const rate = Number(field === "rate" ? value : updatedItem.rate) || 0;
            const discount = Number(field === "discount" ? value : updatedItem.discount) || 0;

            updatedItem.total = Math.max(qty * rate - discount, 0);

            updatedProcedures[index] = updatedItem;

            return {
                ...prev,
                procedures: updatedProcedures,
            };
        });
    };

    const removeProcedureRow = (index) => {
        setConsultation((prev) => ({
            ...prev,
            procedures: prev.procedures.filter((_, i) => i !== index),
        }));
    };

    const handlePrintPrescription = () => {
        const prescriptionRows = consultation.prescription
            .filter((item) => item.medicine || item.dosage || item.duration)
            .map(
                (item) => `
            <tr>
              <td>${item.medicine || ""}</td>
              <td>${item.dosage || ""}</td>
              <td>${item.duration || ""}</td>
            </tr>
          `
            )
            .join("");

        const printWindow = window.open("", "_blank", "width=900,height=1100");

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            
            <head>
                <title>Prescription</title>
                <style>
                    @page {
                        size: A4;
                        margin: 12mm;
                    }
            
                    * {
                        box-sizing: border-box;
                    }
            
                    body {
                        margin: 0;
                        font-family: Arial, sans-serif;
                        color: #111827;
                        background: #fff;
                    }
            
                    .prescription-page {
                        width: 210mm;
                        min-height: 297mm;
                        padding: 14mm;
                        margin: 0 auto;
                        background: #fff;
                        position: relative;
                    }
            
                    .navy {
                        color: #062a63;
                    }
            
                    .header {
                        border-bottom: 2px solid #062a63;
                        padding-bottom: 12px;
                    }
            
                    .top-header {
                        display: grid;
                        grid-template-columns: 90px 1fr;
                        gap: 16px;
                        align-items: center;
                    }
            
                    .logo-box {
                        width: 76px;
                        height: 76px;
                        border: 2px solid #062a63;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        background: #fff;
                    }
            
                    .logo-box img {
                        width: 62px;
                        height: 62px;
                        object-fit: contain;
                        display: block;
                    }
                        .logo-wrap {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            gap: 4px;
                            }

                            .logo-reg {
                            font-size: 14px;
                            font-weight: 800;
                            color: #062a63;
                            white-space: nowrap;
                            }
        
                    .clinic-title {
                        text-align: center;
                    }
            
                    .clinic-title h1 {
                        margin: 0;
                        font-size: 27px;
                        letter-spacing: 1px;
                        font-weight: 800;
                        color: #062a63;
                        text-transform: uppercase;
                    }
            
                    .clinic-title .tag {
                        display: inline-block;
                        margin-top: 5px;
                        padding: 3px 14px;
                        border: 1px solid #062a63;
                        border-radius: 20px;
                        font-size: 13px;
                        font-weight: 700;
                        color: #062a63;
                    }
            
                    .doctor-name {
                        margin-top: 8px;
                        font-size: 18px;
                        font-weight: 800;
                        color: #062a63;
                    }
            
                    .doctor-role {
                        margin-top: 4px;
                        font-size: 15px;
                        font-weight: 600;
                        color: #062a63;
                    }
            
                    .branches {
                        display: grid;
                        grid-template-columns: 0.92fr 1.08fr;
                        gap: 34px;
                        margin-top: 16px;
                    }
            
                    .branch {
                        color: #062a63;
                        font-size: 13px;
                        line-height: 1.6;
                    }
            
                    .branch:first-child {
                        border-right: none;
                        padding-right: 0;
                    }
            
                    .branch:nth-child(2) {
                        border-left: 2px solid #062a63;
                        padding-left: 15px;
                        margin-left: 20px;
                    }
            
                    .branch h3 {
                        margin: 0 0 5px;
                        font-size: 15px;
                        text-decoration: underline;
                        color: #062a63;
                    }
            
                    .patient-row {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 28px;
                        padding: 16px 0 12px;
                        border-bottom: 1px solid #062a63;
                        color: #062a63;
                    }
            
                    .field {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 15px;
                        font-weight: 700;
                    }
            
                    .line {
                        flex: 1;
                        border-bottom: 1px solid #062a63;
                        min-height: 18px;
                        color: #111827;
                        padding-left: 8px;
                        font-weight: 600;
                    }
            
                    .content {
                        min-height: 145mm;
                        padding-top: 12px;
                    }
            
                    .rx {
                        font-size: 30px;
                        color: #062a63;
                        font-family: Georgia, serif;
                        margin-bottom: 6px;
                    }
            
                    .prescription-content {
                        font-size: 14px;
                        line-height: 1.35;
                        padding-left: 24px;
                    }
            
                    .prescription-content p {
                        margin: 0 0 4px;
                    }
            
                    .prescription-content ul,
                    .prescription-content ol {
                        margin: 4px 0 8px;
                        padding-left: 18px;
                    }
            
                    .prescription-content li {
                        margin-bottom: 3px;
                        padding-left: 0;
                    }
            
                    .prescription-content strong {
                        font-weight: 700;
                    }
            
                    .prescription-content .ql-editor {
                        padding: 0;
                    }
            
                    .prescription-content p:empty {
                        display: none;
                    }
            
                    .prescription-content br {
                        line-height: 1;
                    }
            
                    .prescription-content {
                        font-size: 13px;
                        line-height: 1.25;
                    }
            
                    .prescription-content ul,
                    .prescription-content ol {
                        margin: 2px 0 5px;
                    }
            
                    .footer {
                        position: absolute;
                        left: 14mm;
                        right: 14mm;
                        bottom: 12mm;
                        border-top: 2px solid #062a63;
                        padding-top: 10px;
                        color: #062a63;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        font-size: 13px;
                        font-weight: 700;
                    }
            
                    .signature {
                        text-align: right;
                    }
            
                    .signature-line {
                        width: 180px;
                        border-top: 1px solid #062a63;
                        margin-bottom: 6px;
                    }
            
                    .prescription-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 6px;
                        font-size: 14px;
                    }
            
                    .prescription-table th {
                        color: #062a63;
                        text-align: left;
                        border: 1px solid #062a63;
                        padding: 7px 8px;
                        font-weight: 700;
                    }
            
                    .prescription-table td {
                        border: 1px solid #9ca3af;
                        padding: 7px 8px;
                        color: #111827;
                    }
            
                    .empty-text {
                        text-align: center;
                        color: #6b7280;
                        font-weight: 600;
                    }
            
                    .advice-section {
                        margin-top: 14px;
                        font-size: 14px;
                        line-height: 1.45;
                    }
            
                    .advice-section strong {
                        color: #062a63;
                    }
            
                    .advice-section p {
                        margin: 6px 0 0;
                        white-space: pre-line;
                    }
            
            
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
            
                        .prescription-page {
                            margin: 0;
                            width: auto;
                            min-height: auto;
                        }
                    }
                </style>
            </head>
            
            <body>
                <div class="prescription-page">
                    <div class="header">
                        <div class="top-header">
                            <div class="logo-wrap">
  <div class="logo-box">
    <img src="${LogoImg}" alt="Kayathri Dental Care Logo" />
  </div>
  <div class="logo-reg">Reg No: 18590</div>
</div>
            
                            <div class="clinic-title">
                                <h1>Dr. Kayathri's Dental Care</h1>
                                <div class="tag">Multispeciality Centre</div>
                                <div class="doctor-name">Dr. R. Kayathri</div>
                                <div class="doctor-role">Chief Dental Surgeon</div>
                            </div>
                        </div>
            
                        <div class="branches">
                            <div class="branch">
                                <h3>Branch 1</h3>
                                <div>VSR Sports Complex, 1st Floor,</div>
                                <div>Kamaraj High Road, Old Perungalathur,</div>
                                <div>Chennai - 600063.</div>
                                <div><strong>Ph:</strong> 99529 29674</div>
                            </div>
            
                            <div class="branch">
                                <h3>Branch 2</h3>
                                <div>MRL Gita Garden, No. 5,</div>
                                <div>MRL Gita Garden, Nellikuppam Road,</div>
                                <div>Nallambakkam, Chennai - 600127.</div>
                                <div><strong>Ph:</strong> 78128 92480</div>
                            </div>
                        </div>
                    </div>
            
                    <div class="patient-row">
                        <div>
                            <div class="field">
                                <span>Name:</span>
                                <span class="line">Ravi Kumar</span>
                            </div>
            
                            <div class="field" style="margin-top: 12px;">
                                <span>Age:</span>
                                <span class="line">30</span>
                            </div>
                        </div>
            
                        <div>
                            <div class="field">
                                <span>Date:</span>
                                <span class="line">${new Date().toLocaleDateString("en-IN")}</span>
                            </div>
                        </div>
                    </div>
            
                    <div class="content">
                        <div class="rx">Rx</div>
            
                        <div class="prescription-content">
                            <table class="prescription-table">
                                <thead>
                                    <tr>
                                        <th>Medicine</th>
                                        <th>Dosage</th>
                                        <th>Duration</th>
                                    </tr>
                                </thead>
            
                                <tbody>
                                    ${prescriptionRows ||
            `
                                    <tr>
                                        <td colspan="3" class="empty-text">No prescription entered</td>
                                    </tr>
                                    `
            }
                                </tbody>
                            </table>
            
                            <div class="advice-section">
                                <strong>Advice / Remarks:</strong>
                                <p>${consultation.advice || ""}</p>
                            </div>
                        </div>
            
                    </div>
            
                    <div class="footer">
                        <div>
                            Kayathri Dental Care<br />
                            Healthy smiles with gentle care
                        </div>
            
                        <div class="signature">
                            <div class="signature-line"></div>
                            Doctor Signature
                        </div>
                    </div>
                </div>
            
                <script>
                    window.onload = function () {
                        window.print();
                        window.onafterprint = function () {
                            window.close();
                        };
                    };
                </script>
            </body>
            
            </html>
            `);

        printWindow.document.close();
    };

    const InfoItem = ({ label, value }) => (
        <div className="info-item info-item-inline">
            <span>{label}:</span>
            <strong>{value || "-"}</strong>
        </div>
    );

    const VitalInput = ({ label, name, value, onChange, icon }) => (
        <div className="vital-box">
            {/* <div className="vital-icon">
                <i className={`bi ${icon}`}></i>
            </div> */}

            <div className="flex-grow-1">
                <label>{label}</label>
                <input
                    type="text"
                    name={name}
                    className="form-control form-control-sm"
                    value={value}
                    onChange={onChange}
                />
            </div>
        </div>
    );

    const dosageOptions = [
        { key: "morning", label: "M" },
        { key: "afternoon", label: "A" },
        { key: "night", label: "N" },
    ];

    const getDosageParts = (dosage) => {
        const parts = (dosage || "0-0-0").split("-");

        return {
            morning: parts[0] || "0",
            afternoon: parts[1] || "0",
            night: parts[2] || "0",
        };
    };

    const handleDosageCheck = (index, key, checked) => {
        const current = getDosageParts(consultation.prescription[index].dosage);

        const updated = {
            ...current,
            [key]: checked ? "1" : "0",
        };

        const dosageValue = `${updated.morning}-${updated.afternoon}-${updated.night}`;

        handlePrescriptionChange(index, "dosage", dosageValue);
    };

    const handleSaveConsultation = async (e) => {
        e.preventDefault();

        const sessionUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");

        const medicines = consultation.prescription
            .filter((item) => item.medicine || item.dosage || item.duration)
            .map((item) => {
                const dosageParts = getDosageParts(item.dosage);

                return {
                    MedicineName: item.medicine,
                    Morning: dosageParts.morning === "1",
                    Afternoon: dosageParts.afternoon === "1",
                    Night: dosageParts.night === "1",
                    DaysCount: Number(item.duration) || 0,
                    Qty: "",
                    Notes: consultation.advice || "",
                };
            });

        const payload = {
            OrgId: sessionUserData?.OrgId || 1,
            UserId: sessionUserData?.Id || 1,
            JsonData: {
                AppointmentId: Number(appointment?.AppointmentId || appointmentId),
                Diagnosis: consultation.diagnosis,
                TreatmentPlan: consultation.treatmentPlan,
                FollowUpDate: consultation.followUpDate,

                Medicines: medicines,

                Procedures: consultation.procedures
                    .filter((item) => item.procedureName || item.rate || item.total)
                    .map((item) => ({
                        ProcedureId: Number(item.procedureId) || 1,
                        Qty: Number(item.qty) || 1,
                        Rate: Number(item.rate) || 0,
                        Discount: Number(item.discount) || 0,
                        Total: Number(item.total) || 0,
                        Notes: item.notes || "",
                        IsPaid: item.isPaid ? 1 : 0,
                        PaidAmount: Number(item.paidAmount) || 0,
                    })),
            },
        };

        try {
            const response = await saveConsultation(payload);

            if (response?.success) {
                Toast.fire({
                    icon: "success",
                    title: response?.message || "Consultation saved successfully",
                });
            } else {
                Toast.fire({
                    icon: "error",
                    title: response?.message || "Failed to save consultation",
                });
            }
        } catch (error) {
            console.error("Save consultation failed:", error.response?.data || error.message);

            Toast.fire({
                icon: "error",
                title: error.response?.data?.message || "Failed to save consultation",
            });
        }
    };

    useEffect(() => {
        if (!sessionUserData?.OrgId || !appointment?.UnitId) return;

        fetchProcedureMasters(sessionUserData.OrgId, appointment.UnitId);
    }, [sessionUserData?.OrgId, appointment?.UnitId]);

    const handleViewPatientAppointment = async (item) => {
        try {
            setPreviewLoadingId(item.AppointmentId);

            const payload = {
                AppointmentId: item.AppointmentId,
            };

            const response = await appointmentDetailsById(payload);

            if (response?.success) {
                setAppointmentPreview(response);

                bindPreviewToForm(response);

                setActiveScreenTab("overview");
                setActiveClinicalTab("diagnosis");
            }
        } catch (error) {
            console.error("Failed to fetch appointment preview:", error.response?.data || error.message);
        } finally {
            setPreviewLoadingId(null);
        }
    };

    const bindPreviewToForm = (preview) => {
        const appointmentData = preview?.appointment || {};
        const medicines = preview?.medicines || [];
        const procedures = preview?.procedures || [];

        setMedicalHistory({
            allergy: appointmentData.Allergy && appointmentData.Allergy !== "None" ? "Yes" : "No",
            bpHistory: appointmentData.BP ? "Yes" : "No",
            diabetes: appointmentData.Diabetes ? "Yes" : "No",
            medications: appointmentData.Medications ? "Yes" : "No",
            epilepsy: Boolean(appointmentData.Epilepsy),
            asthma: Boolean(appointmentData.Asthma),
            others: Boolean(appointmentData.OtherConditions),
        });

        setMedicalDetails({
            allergyDetails: appointmentData.Allergy === "None" ? "" : appointmentData.Allergy || "",
            diabetesDetails: appointmentData.Diabetes ? "Diabetes" : "",
            medicationDetails: appointmentData.Medications || "",
            othersDetails: appointmentData.OtherConditions || "",
        });

        setVitals({
            bloodPressure: appointmentData.BP || "",
            heartRate: appointmentData.HeartRate || "",
            temperature: appointmentData.Temperature || "",
            weight: appointmentData.Weight || "",
        });

        setConsultation((prev) => ({
            ...prev,
            diagnosis: appointmentData.Diagnosis || "",
            treatmentPlan: appointmentData.TreatmentPlan || "",
            followUpDate: toInputDate(appointmentData.FollowUpDate),
            advice: medicines?.[0]?.Notes || "",

            prescription:
                medicines.length > 0
                    ? medicines.map((med) => ({
                        id: med.Id,
                        medicine: med.MedicineName || "",
                        dosage: `${med.Morning ? "1" : "0"}-${med.Afternoon ? "1" : "0"}-${med.Night ? "1" : "0"}`,
                        duration: med.DaysCount || "",
                        qty: med.Qty || "",
                        notes: med.Notes || "",
                    }))
                    : [
                        {
                            medicine: "",
                            dosage: "0-0-0",
                            duration: "",
                        },
                    ],

            procedures:
                procedures.length > 0
                    ? procedures.map((proc) => ({
                        appointmentProcedureId: proc.AppointmentProcedureId,
                        procedureId: proc.ProcedureId || 1,
                        procedureName: proc.ProcedureName || "",
                        qty: proc.Qty || 1,
                        rate: proc.Rate || "",
                        discount: proc.Discount || "",
                        total: proc.Total || "",
                        notes: proc.Notes || "",
                        isPaid: Boolean(proc.IsPaid),
                        paidAmount: proc.PaidAmount || "",
                    }))
                    : [
                        {
                            procedureId: 1,
                            procedureName: "",
                            qty: 1,
                            rate: "",
                            discount: "",
                            total: "",
                            notes: "",
                            isPaid: false,
                            paidAmount: "",
                        },
                    ],
        }));
    };

    const getReportIcon = (fileType) => {
        if (fileType === "image") return "bi bi-file-earmark-image text-success";
        if (fileType === "pdf") return "bi bi-file-earmark-pdf text-danger";
        if (fileType === "excel") return "bi bi-file-earmark-spreadsheet text-success";
        if (fileType === "word") return "bi bi-file-earmark-word text-primary";

        return "bi bi-file-earmark text-muted";
    };

    const getFilePreviewUrl = (report) => {
        const fileType = report?.FileType || report?.type;

        if (fileType === "image") {
            return `${BASE_IMAGE_API_GET}${report?.FileUrl}`;
        }

        return `${BASE_DOCS_API_GET}${report?.FileUrl}`;
    };

    const handleDownloadFile = (report) => {
        Swal.fire({
            title: "Download File?",
            text: `Do you want to download ${report?.FileName}?`,
            icon: "question",

            showCancelButton: true,

            confirmButtonText:
                '<i class="bi bi-download me-2"></i>Yes Download',

            cancelButtonText:
                '<i class="bi bi-x-circle me-2"></i>No',

            reverseButtons: true,

            customClass: {
                confirmButton: "btn btn-primary mx-2",
                cancelButton: "btn btn-light mx-2",
            },

            buttonsStyling: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const fileUrl = getFilePreviewUrl(report);

                // direct download
                fetch(fileUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                        const blobUrl = window.URL.createObjectURL(blob);

                        const link = document.createElement("a");
                        link.href = blobUrl;
                        link.download = report?.FileName || "file";

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);

                        window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch(() => {
                        Toast.fire({
                            icon: "error",
                            title: "Failed to download file",
                        });
                    });
            }
        });
    };

    return (
        <ReceptionistLayout>
            {/* Patient Details */}
            <div className="col-12">
                <div className="premium-panel premium-panel-compact h-100">
                    <div className="section-head compact-head">
                        <div className="d-flex align-items-center gap-3">
                            <div className="section-icon">
                                <i className="bi bi-person-vcard"></i>
                            </div>

                            <div>
                                <h3>Patient Details</h3>
                                <p>Appointment and personal information</p>
                            </div>
                        </div>

                        <div className="text-end">
                            <div className="appointment-date">{appointment.date}</div>
                            <span className="status-pill">{appointment.status}</span>
                        </div>
                    </div>

                    <div className="patient-grid patient-grid-compact">
                        <InfoItem label="Name" value={appointment.patient} />
                        <InfoItem label="Age" value={appointment.age} />
                        <InfoItem label="Gender" value={appointment.gender} />
                        <InfoItem label="Blood Group" value={appointment.bloodGroup} />
                        <InfoItem label="Phone" value={appointment.phone} />
                        {/* <InfoItem label="Doctor" value={appointment.doctor} /> */}
                    </div>
                </div>
            </div>

            <div className="col-12">
                <div className="clinical-tabs mb-0">
                    {[
                        ["history", "History", "bi-clock-history"],
                        // ["overview", "Overview", "bi-layout-text-window-reverse"],
                    ].map(([key, label, icon]) => (
                        <button
                            key={key}
                            type="button"
                            className={`clinical-tab-btn ${activeScreenTab === key ? "active" : ""}`}
                            onClick={() => setActiveScreenTab(key)}
                        >
                            <i className={`bi ${icon}`}></i>
                            <span>{label}</span>
                        </button>
                    ))}
                </div>

                <div className="row g-4">
                    {activeScreenTab === "overview" && (
                        <div className="consultation-page">
                            <div className="row g-4">

                                {/* Medical History */}
                                <div className="col-12 col-xl-3">
                                    <div className="premium-panel h-100">
                                        <div className="section-head">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="section-icon bg-light-danger">
                                                    <i className="bi bi-heart-pulse"></i>
                                                </div>

                                                <div>
                                                    <h3>Medical History</h3>
                                                    <p>Health conditions and medication details</p>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row g-3 compact-form">
                                            <div className="col-md-6">
                                                <label>Allergy</label>
                                                <select
                                                    name="allergy"
                                                    className="form-select form-select-sm"
                                                    value={medicalHistory.allergy}
                                                    onChange={handleMedicalHistoryChange}
                                                >
                                                    <option value="No">No</option>
                                                    <option value="Yes">Yes</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label>Blood Pressure</label>
                                                <select
                                                    name="bpHistory"
                                                    className="form-select form-select-sm"
                                                    value={medicalHistory.bpHistory}
                                                    onChange={handleMedicalHistoryChange}
                                                >
                                                    <option value="No">No</option>
                                                    <option value="Yes">Yes</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label>Diabetes Mellitus</label>
                                                <select
                                                    name="diabetes"
                                                    className="form-select form-select-sm"
                                                    value={medicalHistory.diabetes}
                                                    onChange={handleMedicalHistoryChange}
                                                >
                                                    <option value="No">No</option>
                                                    <option value="Yes">Yes</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label>Medications</label>
                                                <select
                                                    name="medications"
                                                    className="form-select form-select-sm"
                                                    value={medicalHistory.medications}
                                                    onChange={handleMedicalHistoryChange}
                                                >
                                                    <option value="No">No</option>
                                                    <option value="Yes">Yes</option>
                                                </select>
                                            </div>

                                            <div className="col-md-12">
                                                <label>Conditions</label>

                                                <div className="condition-row">
                                                    <label className={`condition-chip ${medicalHistory.epilepsy ? "active" : ""}`}>
                                                        <input
                                                            type="checkbox"
                                                            name="epilepsy"
                                                            checked={medicalHistory.epilepsy}
                                                            onChange={handleMedicalHistoryChange}
                                                        />
                                                        Epilepsy
                                                    </label>

                                                    <label className={`condition-chip ${medicalHistory.asthma ? "active" : ""}`}>
                                                        <input
                                                            type="checkbox"
                                                            name="asthma"
                                                            checked={medicalHistory.asthma}
                                                            onChange={handleMedicalHistoryChange}
                                                        />
                                                        Asthma
                                                    </label>

                                                    <label className={`condition-chip ${medicalHistory.others ? "active" : ""}`}>
                                                        <input
                                                            type="checkbox"
                                                            name="others"
                                                            checked={medicalHistory.others}
                                                            onChange={handleMedicalHistoryChange}
                                                        />
                                                        Others
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Vital Signs */}
                                <div className="col-12 col-xl-6">
                                    <div className="premium-panel h-100">
                                        <div className="section-head">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="section-icon bg-light-warning">
                                                    <i className="bi bi-activity"></i>
                                                </div>

                                                <div>
                                                    <h3>Vital Signs</h3>
                                                    <p>Clinical measurements</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row g-3">
                                            {medicalHistory.bpHistory === "Yes" && (
                                                <div className="col-12 col-md-3">
                                                    <VitalInput
                                                        label="Blood Pressure"
                                                        name="bloodPressure"
                                                        value={vitals.bloodPressure}
                                                        onChange={handleVitalsChange}
                                                        icon="bi-heart-pulse"
                                                    />
                                                </div>
                                            )}

                                            <div className="col-12 col-md-3">
                                                <VitalInput
                                                    label="Heart Rate"
                                                    name="heartRate"
                                                    value={vitals.heartRate}
                                                    onChange={handleVitalsChange}
                                                    icon="bi-activity"
                                                />
                                            </div>

                                            <div className="col-12 col-md-3">
                                                <VitalInput
                                                    label="Temperature"
                                                    name="temperature"
                                                    value={vitals.temperature}
                                                    onChange={handleVitalsChange}
                                                    icon="bi-thermometer-half"
                                                />
                                            </div>

                                            <div className="col-12 col-md-3">
                                                <VitalInput
                                                    label="Weight"
                                                    name="weight"
                                                    value={vitals.weight}
                                                    onChange={handleVitalsChange}
                                                    icon="bi-speedometer2"
                                                />
                                            </div>
                                        </div>

                                        <div className="row g-3 compact-form mt-2">
                                            {medicalHistory.allergy === "Yes" && (
                                                <div className="col-md-3">
                                                    <label>Allergy Details</label>
                                                    <input
                                                        type="text"
                                                        name="allergyDetails"
                                                        className="form-control form-control-sm"
                                                        placeholder="Mention allergy"
                                                        value={medicalDetails.allergyDetails}
                                                        onChange={handleMedicalDetailsChange}
                                                    />
                                                </div>
                                            )}

                                            {medicalHistory.diabetes === "Yes" && (
                                                <div className="col-md-3">
                                                    <label>Diabetes Details</label>
                                                    <input
                                                        type="text"
                                                        name="diabetesDetails"
                                                        className="form-control form-control-sm"
                                                        placeholder="Type / medicine details"
                                                        value={medicalDetails.diabetesDetails}
                                                        onChange={handleMedicalDetailsChange}
                                                    />
                                                </div>
                                            )}

                                            {medicalHistory.medications === "Yes" && (
                                                <div className="col-md-3">
                                                    <label>Medication Details</label>
                                                    <input
                                                        type="text"
                                                        name="medicationDetails"
                                                        className="form-control form-control-sm"
                                                        placeholder="Current medications"
                                                        value={medicalDetails.medicationDetails}
                                                        onChange={handleMedicalDetailsChange}
                                                    />
                                                </div>
                                            )}

                                            {medicalHistory.others && (
                                                <div className="col-md-6">
                                                    <label>Other Condition Details</label>
                                                    <input
                                                        type="text"
                                                        name="othersDetails"
                                                        className="form-control form-control-sm"
                                                        placeholder="Mention other condition"
                                                        value={medicalDetails.othersDetails}
                                                        onChange={handleMedicalDetailsChange}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Medical Reports */}
                                <div className="col-12 col-xl-3">
                                    <div className="premium-panel h-100">
                                        <div className="section-head">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="section-icon bg-light-success">
                                                    <i className="bi bi-file-earmark-medical"></i>
                                                </div>

                                                <div>
                                                    <h3>Medical Reports</h3>
                                                    <p>Uploaded files and documents</p>
                                                </div>
                                            </div>

                                            {/* <button
                                                type="button"
                                                className="btn btn-sm btn-light-success fw-bold"
                                                onClick={handleAddReport}
                                            >
                                                <i className="bi bi-plus-circle me-1"></i>
                                                Add
                                            </button> */}
                                        </div>

                                        <div className="row g-2">
                                            {[...appointmentFiles]
                                                .slice(0, 4)
                                                .map((report, index) => (
                                                    <div
                                                        key={`${report.FileName}-${index}`}
                                                        className="col-12"
                                                    >
                                                        <div className="report-tile h-100 w-100 d-flex align-items-center gap-2">

                                                            <i
                                                                className={
                                                                    report.icon ||
                                                                    getReportIcon(report.FileType || report.type)
                                                                }
                                                            ></i>

                                                            <span className="text-truncate">
                                                                {report.FileName}
                                                            </span>

                                                            <div className="report-overlay d-flex align-items-center justify-content-center gap-2">

                                                                {/* DOWNLOAD */}
                                                                <button
                                                                    className="btn btn-sm rounded-circle border-0 d-flex align-items-center justify-content-center p-0"
                                                                    onClick={() => handleDownloadFile(report)}
                                                                    type="button"
                                                                    style={{
                                                                        width: "42px",
                                                                        height: "42px",
                                                                        background:
                                                                            "linear-gradient(135deg,#2563eb,#3b82f6)",
                                                                        boxShadow: "0 8px 18px rgba(37,99,235,0.35)",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="bi bi-download text-white"
                                                                        style={{
                                                                            fontSize: "16px",
                                                                            lineHeight: 1,
                                                                            display: "flex",
                                                                        }}
                                                                    ></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Diagnosis and Prescription */}
                                <div className="col-12">
                                    <div className="premium-panel">
                                        <div className="section-head">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="section-icon bg-light-info">
                                                    <i className="bi bi-clipboard2-pulse"></i>
                                                </div>

                                                <div>
                                                    <h3>Diagnosis and Treatment Plan</h3>
                                                    <p>Clinical notes, medicines, procedures, and advice</p>
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                className="premium-print-btn"
                                                onClick={handlePrintPrescription}
                                            >
                                                <span className="print-btn-icon">
                                                    <i className="bi bi-printer text-white"></i>
                                                </span>
                                                <span>Print</span>
                                            </button>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
                                            <div className="clinical-tabs mb-0">
                                                {[
                                                    ["diagnosis", "Diagnosis & Treatment Plan", "bi-clipboard2-pulse"],
                                                    ["prescription", "Prescription", "bi-capsule"],
                                                    ["procedures", "Procedures", "bi-receipt-cutoff"],
                                                ].map(([key, label, icon]) => (
                                                    <button
                                                        key={key}
                                                        type="button"
                                                        className={`clinical-tab-btn ${activeClinicalTab === key ? "active" : ""}`}
                                                        onClick={() => setActiveClinicalTab(key)}
                                                    >
                                                        <i className={`bi ${icon}`}></i>
                                                        <span>{label}</span>
                                                    </button>
                                                ))}
                                            </div>
                                            {sessionUserData?.RoleId !== 3 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success fw-bold rounded-3 px-4 py-3 clinical-save-btn"
                                                    onClick={handleSaveConsultation}
                                                >
                                                    <i className="bi bi-check-circle me-2"></i>
                                                    Save & Complete Consultation
                                                </button>
                                            )}
                                        </div>

                                        <div>
                                            {activeClinicalTab === "diagnosis" && (
                                                <div className="row clinical-tab-panel">
                                                    <div className=" col-12 col-md-6 col-xl-6">
                                                        <label>Diagnosis</label>
                                                        <textarea
                                                            rows="6"
                                                            name="diagnosis"
                                                            className="form-control"
                                                            value={consultation.diagnosis}
                                                            onChange={handleConsultationChange}
                                                            placeholder="Enter diagnosis"
                                                        />
                                                    </div>

                                                    <div className="col-12 col-md-6 col-xl-6">
                                                        <label>Treatment Plan</label>
                                                        <textarea
                                                            rows="6"
                                                            name="treatmentPlan"
                                                            className="form-control"
                                                            value={consultation.treatmentPlan}
                                                            onChange={handleConsultationChange}
                                                            placeholder="Enter treatment plan"
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {activeClinicalTab === "prescription" && (
                                                <div className="clinical-tab-panel">
                                                    <div className="prescription-head">
                                                        <label>Prescription</label>

                                                        {/* <button
                                                            type="button"
                                                            className="btn btn-light-primary btn-sm shadow-sm border border-primary"
                                                            onClick={addPrescriptionRow}
                                                        >
                                                            <i className="bi bi-plus-circle me-1"></i>
                                                            Add Medicine
                                                        </button> */}
                                                    </div>

                                                    <div className="row g-3 align-items-start">
                                                        <div className="col-12 col-xl-7">
                                                            <div className="table-responsive prescription-table-wrap">
                                                                <table className="table table-bordered align-middle mb-0">
                                                                    <colgroup>
                                                                        <col style={{ width: "58%" }} />
                                                                        <col style={{ width: "6%" }} />
                                                                        <col style={{ width: "6%" }} />
                                                                        <col style={{ width: "6%" }} />
                                                                        <col style={{ width: "11%" }} />
                                                                        <col style={{ width: "10%" }} />
                                                                    </colgroup>

                                                                    <thead>
                                                                        <tr>
                                                                            <th rowSpan="2" style={{ verticalAlign: "middle" }}>Medicine</th>
                                                                            <th colSpan="3" className="text-center">Dosage</th>
                                                                            <th rowSpan="2" style={{ verticalAlign: "middle" }}>Duration(days)</th>
                                                                            <th rowSpan="2" className="text-center" style={{ verticalAlign: "middle" }}>Action</th>
                                                                        </tr>

                                                                        <tr>
                                                                            <th className="text-center dosage-sub-head">M</th>
                                                                            <th className="text-center dosage-sub-head">A</th>
                                                                            <th className="text-center dosage-sub-head">N</th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        {consultation.prescription.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td>
                                                                                    <input
                                                                                        className="form-control form-control-sm"
                                                                                        placeholder="Medicine name"
                                                                                        value={item.medicine}
                                                                                        onChange={(e) =>
                                                                                            handlePrescriptionChange(index, "medicine", e.target.value)
                                                                                        }
                                                                                    />
                                                                                </td>

                                                                                {dosageOptions.map((option) => {
                                                                                    const dosageParts = getDosageParts(item.dosage);

                                                                                    return (
                                                                                        <td key={option.key} className="text-center">
                                                                                            <label
                                                                                                className={`dosage-check mx-auto ${dosageParts[option.key] === "1" ? "active" : ""
                                                                                                    }`}
                                                                                            >
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={dosageParts[option.key] === "1"}
                                                                                                    onChange={(e) =>
                                                                                                        handleDosageCheck(index, option.key, e.target.checked)
                                                                                                    }
                                                                                                />
                                                                                                <span>{dosageParts[option.key] === "1" ? "✓" : ""}</span>
                                                                                            </label>
                                                                                        </td>
                                                                                    );
                                                                                })}

                                                                                <td>
                                                                                    <input
                                                                                        className="form-control form-control-sm"
                                                                                        placeholder="5"
                                                                                        value={item.duration}
                                                                                        onChange={(e) =>
                                                                                            handlePrescriptionChange(index, "duration", e.target.value)
                                                                                        }
                                                                                    />
                                                                                </td>

                                                                                <td className="text-center">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-light-danger btn-sm"
                                                                                        onClick={() => removePrescriptionRow(index)}
                                                                                        disabled={consultation.prescription.length === 1 || sessionUserData?.RoleId === 3}
                                                                                    >
                                                                                        <i className="bi bi-trash ms-1"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-xl-5">
                                                            <div className="compact-form">
                                                                <div className="mb-3">
                                                                    <label>Follow Up Date</label>
                                                                    <input
                                                                        type="date"
                                                                        name="followUpDate"
                                                                        className="form-control"
                                                                        value={consultation.followUpDate}
                                                                        onChange={handleConsultationChange}
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <label>Remarks / Advice</label>
                                                                    <textarea
                                                                        rows="5"
                                                                        name="advice"
                                                                        className="form-control"
                                                                        value={consultation.advice}
                                                                        onChange={handleConsultationChange}
                                                                        placeholder="Enter advice or remarks"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeClinicalTab === "procedures" && (
                                                <div className="clinical-tab-panel">
                                                    <div className="prescription-head">
                                                        <label>Procedures</label>

                                                        {/* <button
                                                            type="button"
                                                            className="btn btn-light-success btn-sm shadow-sm border border-success"
                                                            onClick={addProcedureRow}
                                                        >
                                                            <i className="bi bi-plus-circle me-1"></i>
                                                            Add Procedure
                                                        </button> */}
                                                    </div>

                                                    <div className="table-responsive prescription-table-wrap">
                                                        <table className="table table-bordered align-middle mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Procedure</th>
                                                                    <th style={{ width: "5%" }}>Qty</th>
                                                                    <th style={{ width: "9%" }}>Rate</th>
                                                                    <th style={{ width: "9%" }}>Discount</th>
                                                                    <th style={{ width: "9%" }}>Total</th>
                                                                    <th style={{ width: "5%" }}>Paid</th>
                                                                    <th style={{ width: "9%" }}>Paid Amount</th>
                                                                    <th style={{ width: "20%" }}>Notes</th>
                                                                    <th className="text-center" style={{ width: "6%" }}>Action</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {consultation.procedures.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                value={item.procedureId || ""}
                                                                                onChange={(e) => {
                                                                                    const selectedId = Number(e.target.value);

                                                                                    const selectedProcedure = procedures.find(
                                                                                        (proc) => Number(proc.ProcedureId || proc.Id) === selectedId
                                                                                    );

                                                                                    handleProcedureChange(index, "procedureId", selectedId);
                                                                                    handleProcedureChange(
                                                                                        index,
                                                                                        "procedureName",
                                                                                        selectedProcedure?.ProcedureName || selectedProcedure?.Name || ""
                                                                                    );
                                                                                    handleProcedureChange(index, "rate", selectedProcedure?.Rate || "");
                                                                                }}
                                                                            >
                                                                                <option value="">Select Procedure</option>

                                                                                {procedures.map((procedure) => {
                                                                                    const id = procedure.ProcedureId || procedure.Id;
                                                                                    const name = procedure.ProcedureName || procedure.Name;

                                                                                    return (
                                                                                        <option key={id} value={id}>
                                                                                            {name}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control form-control-sm"
                                                                                value={item.qty}
                                                                                onChange={(e) =>
                                                                                    handleProcedureChange(index, "qty", e.target.value)
                                                                                }
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control form-control-sm"
                                                                                value={item.rate}
                                                                                onChange={(e) =>
                                                                                    handleProcedureChange(index, "rate", e.target.value)
                                                                                }
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control form-control-sm"
                                                                                value={item.discount}
                                                                                onChange={(e) =>
                                                                                    handleProcedureChange(index, "discount", e.target.value)
                                                                                }
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                className="form-control form-control-sm"
                                                                                value={item.total}
                                                                                readOnly
                                                                            />
                                                                        </td>

                                                                        <td className="text-center">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={item.isPaid}
                                                                                onChange={(e) =>
                                                                                    handleProcedureChange(index, "isPaid", e.target.checked)
                                                                                }
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control form-control-sm"
                                                                                value={item.paidAmount}
                                                                                onChange={(e) =>
                                                                                    handleProcedureChange(index, "paidAmount", e.target.value)
                                                                                }
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Notes"
                                                                                value={item.notes}
                                                                                onChange={(e) =>
                                                                                    handleProcedureChange(index, "notes", e.target.value)
                                                                                }
                                                                            />
                                                                        </td>

                                                                        <td className="text-center">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-light-danger btn-sm"
                                                                                onClick={() => removeProcedureRow(index)}
                                                                                disabled={consultation.procedures.length === 1 || sessionUserData?.RoleId === 3}
                                                                            >
                                                                                <i className="bi bi-trash"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* History */}
                    {activeScreenTab === "history" && (
                        <div className="col-12 mt-8">
                            <div className="premium-panel">
                                <div className="section-head">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="section-icon section-icon-purple">
                                            <i className="bi bi-clock-history"></i>
                                        </div>

                                        <div>
                                            <h3>History</h3>
                                            <p>Previous visits, treatments, and follow-ups</p>
                                        </div>
                                    </div>

                                    <span className="badge bg-light-primary text-primary fw-bold rounded-pill px-3 py-2">
                                        {appointmentsByPatientId.length} Records
                                    </span>
                                </div>

                                {patientAppointments.length > 0 ? (
                                    <div className="row g-3">
                                        {patientAppointments.map((item, index) => {
                                            const isCurrentRecord = index === 0;

                                            return (
                                                <div key={index} className="col-12 col-md-6 col-xl-4">
                                                    <div
                                                        className={`card rounded-4 h-100 history-hover-card ${isCurrentRecord
                                                            ? "border border-primary border-2 shadow"
                                                            : "border shadow-sm"
                                                            }`}
                                                    >
                                                        <div className="card-body p-4">
                                                            <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    <span
                                                                        className={`badge fw-bold rounded-pill px-3 py-2 ${isCurrentRecord
                                                                            ? "bg-primary text-white"
                                                                            : "bg-light-primary text-primary"
                                                                            }`}
                                                                    >
                                                                        <i className={`bi bi-calendar3 me-2 ${isCurrentRecord ? "text-white" : ""}`}></i>
                                                                        {formatTime(item.SlotTime)}
                                                                    </span>

                                                                    {isCurrentRecord && (
                                                                        <span className="badge bg-light-success text-success fw-bold rounded-pill px-3 py-2">
                                                                            <i className="bi bi-check-circle me-1"></i>
                                                                            Current
                                                                        </span>
                                                                    )}
                                                                </div>

                                                                <button
                                                                    type="button"
                                                                    className={`btn rounded-circle d-flex align-items-center justify-content-center p-0 ${isCurrentRecord ? "btn-primary" : "btn-light-primary"
                                                                        }`}
                                                                    onClick={() => handleViewPatientAppointment(item)}
                                                                    disabled={previewLoadingId === item.AppointmentId}
                                                                    style={{
                                                                        width: "34px",
                                                                        height: "34px",
                                                                        minWidth: "34px",
                                                                        lineHeight: 1,
                                                                    }}
                                                                >
                                                                    {previewLoadingId === item.AppointmentId ? (
                                                                        <span className="spinner-border spinner-border-sm"></span>
                                                                    ) : (
                                                                        <i className="bi bi-eye" style={{ fontSize: "15px", lineHeight: 1 }}></i>
                                                                    )}
                                                                </button>
                                                            </div>

                                                            <h6 className={isCurrentRecord ? "fw-bold text-primary mb-3" : "fw-bold text-dark mb-3"}>
                                                                {item.Status}
                                                            </h6>

                                                            <div className="row g-2">
                                                                <div className="col-6">
                                                                    <div className={isCurrentRecord ? "bg-light-primary rounded-3 p-3 h-100" : "bg-light rounded-3 p-3 h-100"}>
                                                                        <div className="text-muted fs-8 fw-bold mb-1">Doctor</div>
                                                                        <div className="fw-bold text-dark">{item.DoctorName || "-"}</div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-6">
                                                                    <div className={isCurrentRecord ? "bg-light-primary rounded-3 p-3 h-100" : "bg-light rounded-3 p-3 h-100"}>
                                                                        <div className="text-muted fs-8 fw-bold mb-1">Appt Date</div>
                                                                        <div className="fw-bold text-dark">
                                                                            {formatDate(item.AppointmentDate) || "-"}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="border border-dashed rounded-4 bg-light py-10 text-center">
                                        <i className="bi bi-clock-history fs-1 text-muted"></i>
                                        <div className="text-muted fw-bold mt-2">No previous history found</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>


            <style>
                {`
                .history-hover-card {
                    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
                    }

                    .history-hover-card:hover {
                    transform: translateY(-4px);
                    border-color: #0d6efd !important;
                    box-shadow: 0 14px 30px rgba(13, 110, 253, 0.16) !important;
                    }

                    .history-hover-card:hover h6 {
                    color: #0d6efd !important;
                    }


                                    .clinical-tabs {
                display: flex;
                gap: 10px;
                flex-wrap: wrap;
                padding: 8px;
                border-radius: 14px;
                background: #f8fafc;
                border: 1px solid #eef2f7;
                margin-bottom: 18px;
                }

                .clinical-tab-btn {
                border: 0;
                border-radius: 12px;
                padding: 10px 14px;
                background: transparent;
                color: #64748b;
                font-size: 13px;
                font-weight: 800;
                display: inline-flex;
                align-items: center;
                gap: 8px;
                transition: 0.2s ease;
                }

                .clinical-tab-btn:hover {
                background: #eef6ff;
                color: #2563eb;
                }

                .clinical-tab-btn.active {
                    background: linear-gradient(135deg, #0f766e, #2563eb);
                    color: #fff;
                    box-shadow: 0 10px 22px rgba(37, 99, 235, 0.18);
                }
                .clinical-tab-btn.active i {
                    background: linear-gradient(135deg, #0f766e, #2563eb);
                    color: #fff;
                    box-shadow: 0 10px 22px rgba(37, 99, 235, 0.18);
                }

                .clinical-tab-panel {
                padding: 16px;
                border-radius: 14px;
                border: 1px solid #eef2f7;
                background: #fff;
                }

                .clinical-tab-panel label {
                font-size: 13px;
                font-weight: 800;
                color: #374151;
                margin-bottom: 6px;
                }
                .premium-print-btn {
                    border: 0;
                    outline: 0;
                    padding: 9px 18px;
                    border-radius: 14px;
                    background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
                    color: #fff;
                    font-size: 13px;
                    font-weight: 800;
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.22);
                    transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
                    position: relative;
                    overflow: hidden;
                    }

                    .premium-print-btn::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: -80%;
                    width: 55%;
                    height: 100%;
                    background: linear-gradient(
                        90deg,
                        transparent,
                        rgba(255, 255, 255, 0.34),
                        transparent
                    );
                    transform: skewX(-18deg);
                    }

                    .premium-print-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 16px 30px rgba(37, 99, 235, 0.3);
                    filter: saturate(1.08);
                    }

                    .premium-print-btn:hover::before {
                    animation: printBtnShine 0.85s ease;
                    }

                    .premium-print-btn:active {
                    transform: translateY(0);
                    box-shadow: 0 8px 18px rgba(37, 99, 235, 0.2);
                    }

                    .print-btn-icon {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.2);
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    }

                    .print-btn-icon i {
                    font-size: 14px;
                    }

                    @keyframes printBtnShine {
                    from {
                        left: -80%;
                    }

                    to {
                        left: 130%;
                    }
                    }
                .section-head .btn {
                    white-space: nowrap;
                    }
                    .dosage-sub-head {
                        font-size: 12px;
                        font-weight: 800;
                        color: #64748b;
                        background: #f8fafc;
                    }

                    .dosage-check {
                    width: 30px;
                    height: 30px;
                    border-radius: 8px;
                    border: 1px solid #dbe3ef;
                    background: #f8fafc;
                    color: #64748b;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    font-weight: 900;
                    cursor: pointer;
                    }

                    .dosage-check input {
                    display: none;
                    }

                    .dosage-check.active {
                    background: #e0f2fe;
                    border-color: #2563eb;
                    color: #1d4ed8;
                    }
                    .consultation-page {
                    color: #111827;
                    }
                    .report-tile {
                    width: 100%;
                    min-width: 0;
                    padding: 12px;
                    }

                    .report-tile span {
                    font-size: 12px;
                    font-weight: 800;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    }
                    .premium-panel {
                    border: 1px solid #e5e7eb;
                    border-radius: 14px;
                    background: #fff;
                    padding: 20px;
                    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
                    }

                    .section-head {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    gap: 16px;
                    margin-bottom: 18px;
                    padding-bottom: 14px;
                    border-bottom: 1px solid #edf0f5;
                    }

                    .section-head h3 {
                    font-size: 18px;
                    font-weight: 800;
                    color: #111827;
                    margin: 0;
                    }

                    .section-head p {
                    margin: 4px 0 0;
                    color: #6b7280;
                    font-size: 13px;
                    font-weight: 600;
                    }

                    .status-pill {
                    padding: 7px 13px;
                    border-radius: 999px;
                    background: #e0f2fe;
                    color: #0369a1;
                    font-size: 12px;
                    font-weight: 800;
                    white-space: nowrap;
                    }

                 .premium-panel-compact {
                    padding: 16px;
                    }

                    .compact-head {
                    margin-bottom: 12px;
                    padding-bottom: 10px;
                    }

                    .patient-grid-compact {
                    display: grid;
                    grid-template-columns: repeat(5, minmax(0, 1fr));
                    gap: 10px;
                    }

                    .info-item-inline {
                    min-height: 42px;
                    padding: 10px 12px;
                    border-radius: 10px;
                    background: #f8fafc;
                    border: 1px solid #eef2f7;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    }

                    .info-item-inline span {
                    font-size: 12px;
                    color: #6b7280;
                    font-weight: 800;
                    margin-bottom: 0;
                    white-space: nowrap;
                    }\.section-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 10px;
                    background: #eef6ff;
                    color: #2563eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    flex-shrink: 0;
                    }

                    .info-item-inline strong {
                    font-size: 13px;
                    color: #111827;
                    font-weight: 800;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    }

                    .appointment-date {
                    color: #374151;
                    font-size: 13px;
                    font-weight: 800;
                    margin-bottom: 6px;
                    }

                    .status-pill {
                    display: inline-flex;
                    padding: 6px 12px;
                    border-radius: 999px;
                    background: #e0f2fe;
                    color: #0369a1;
                    font-size: 12px;
                    font-weight: 800;
                    white-space: nowrap;
                    }

                    @media (max-width: 991px) {
                    .patient-grid-compact {
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                    }
                    }

                    @media (max-width: 575px) {
                    .patient-grid-compact {
                        grid-template-columns: 1fr;
                    }
                    }
                    .section-icon-purple {
                    background: #f5f3ff;
                    color: #7c3aed;
                    }
                    .complaint-box {
                    min-height: 128px;
                    border-radius: 12px;
                    background: linear-gradient(135deg, #f8fafc, #eef6ff);
                    border: 1px solid #e2e8f0;
                    padding: 16px;
                    color: #374151;
                    font-weight: 600;
                    line-height: 1.6;
                    }

                    .compact-form label,
                    .vital-box label,
                    .prescription-head label {
                    font-size: 13px;
                    font-weight: 800;
                    color: #374151;
                    margin-bottom: 6px;
                    }

                    .compact-form .form-control,
                    .compact-form .form-select {
                    min-height: 38px;
                    border-radius: 10px;
                    border-color: #e5e7eb;
                    background-color: #fbfdff;
                    }

                    .condition-row {
                    display: flex;
                    gap: 10px;
                    flex-wrap: wrap;
                    }

                    .condition-chip {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    min-height: 38px;
                    padding: 8px 12px;
                    border-radius: 999px;
                    border: 1px solid #e5e7eb;
                    background: #f8fafc;
                    color: #374151;
                    font-size: 13px;
                    font-weight: 700;
                    cursor: pointer;
                    }

                    .condition-chip input {
                    margin: 0;
                    }

                    .condition-chip.active {
                    border-color: #2563eb;
                    background: #eff6ff;
                    color: #1d4ed8;
                    }

                    .vital-box {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 14px;
                    border-radius: 12px;
                    background: #f8fafc;
                    border: 1px solid #eef2f7;
                    }

                    .vital-icon {
                    width: 42px;
                    height: 42px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #e0f2fe;
                    color: #0369a1;
                    font-size: 20px;
                    flex-shrink: 0;
                    }

                    .report-tile {
                    min-width: 130px;
                    padding: 14px 16px;
                    border-radius: 12px;
                    background: #f8fafc;
                    border: 1px solid #eef2f7;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-weight: 800;
                    color: #374151;
                    }

                    .report-tile i {
                    font-size: 22px;
                    }

                    .report-tile.add {
                    color: #047857;
                    background: #ecfdf5;
                    border-color: #bbf7d0;
                    }

                    .prescription-head {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                    }

                    .prescription-table-wrap {
                    border-radius: 12px;
                    border: 1px solid #e5e7eb;
                    }

                    .prescription-table-wrap table {
                    margin-bottom: 0;
                    }

                    .prescription-table-wrap thead th {
                    background: #f8fafc;
                    font-size: 13px;
                    font-weight: 800;
                    color: #374151;
                    }

                    @media (max-width: 767px) {

                    .patient-grid,
                    .vitals-grid {
                        grid-template-columns: 1fr;
                    }

                    .section-head {
                        flex-direction: column;
                    }
                    }

                    .history-count {
                    padding: 7px 12px;
                    border-radius: 999px;
                    background: #f1f5f9;
                    color: #475569;
                    font-size: 12px;
                    font-weight: 800;
                    white-space: nowrap;
                    }

                    .premium-table-wrap {
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    overflow: hidden;
                    }

                    .premium-table thead th {
                    background: #f8fafc;
                    color: #374151;
                    font-size: 13px;
                    font-weight: 800;
                    padding: 12px 14px;
                    border-bottom: 1px solid #e5e7eb;
                    white-space: nowrap;
                    }

                    .premium-table tbody td {
                    padding: 12px 14px;
                    color: #4b5563;
                    font-size: 13px;
                    font-weight: 700;
                    border-bottom: 1px solid #f1f5f9;
                    vertical-align: middle;
                    }

                    .premium-table tbody tr:last-child td {
                    border-bottom: 0;
                    }

                    .premium-table tbody tr:hover {
                    background: #fbfdff;
                    }

                    .treatment-text {
                    max-width: 260px;
                    color: #111827;
                    font-weight: 800;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    }

                    .appt-pill {
                    display: inline-flex;
                    padding: 6px 10px;
                    border-radius: 999px;
                    background: #eef6ff;
                    color: #0369a1;
                    font-size: 12px;
                    font-weight: 800;
                    white-space: nowrap;
                    }

                    .fee-paid {
                    color: #047857;
                    font-weight: 900;
                    }

                    .balance-due {
                    color: #dc2626;
                    font-weight: 900;
                    }

                    .balance-clear {
                    color: #047857;
                    font-weight: 900;
                    }

                    .view-btn {
                    border-radius: 999px;
                    padding-inline: 12px;
                    }

                    .empty-history {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 7px;
                    color: #94a3b8;
                    font-weight: 800;
                    }

                    .empty-history i {
                    font-size: 28px;
                    }
                `}
            </style>
        </ReceptionistLayout>
    );
}
